import { h } from 'preact';
import * as BaseComp from 'components/pages/home/cta/cta.js';
// import s from 'components/pages/home/cta/cta.sss';

export default class Cta extends BaseComp.default {

}
